import React, { useState, useEffect } from 'react';
import axios from 'axios';
import style from './Contact.module.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        nombre: '',
        mail: '',
        telefono: '',
        direccion: '',
        asunto: '',
        mensaje: '',
    });
    const [isSending, setIsSending] = useState(false);
    const [status, setStatus] = useState({ type: '', message: '' });

    useEffect(() => {
        if (!status.message) return undefined;

        const timer = setTimeout(() => {
            setStatus({ type: '', message: '' });
        }, 4000);

        return () => clearTimeout(timer);
    }, [status.message]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((current) => ({ ...current, [name]: value }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsSending(true);
        setStatus({ type: '', message: '' });

        try {
            const response = await axios.post('/contacto', {
                nombre: formData.nombre.trim(),
                mail: formData.mail.trim(),
                telefono: formData.telefono.trim(),
                asunto: formData.asunto.trim(),
                mensaje: [
                    formData.direccion && `Dirección: ${formData.direccion}`,
                    formData.mensaje,
                ].filter(Boolean).join('\n'),
                origen: 'web',
            });

            if (!response.data.success) {
                throw new Error(response.data.message || 'No se pudo enviar la consulta');
            }

            setFormData({
                nombre: '',
                mail: '',
                telefono: '',
                direccion: '',
                asunto: '',
                mensaje: '',
            });
            setStatus({
                type: 'success',
                message: 'Tu consulta fue enviada correctamente. Nos contactaremos a la brevedad.',
            });
        } catch (error) {
            setStatus({
                type: 'error',
                message: error.response?.data?.message || 'No pudimos enviar tu consulta. Intentá nuevamente.',
            });
        } finally {
            setIsSending(false);
        }
    };

    return (
        <div className={style.formContent}>
            <div className={style.layout}>
                <div className={style.infoPanel}>
                    <span className={style.infoEyebrow}>Estamos para ayudarte</span>
                    <h1 className={style.infoTitle}>Hablemos sobre tu próximo paso</h1>
                    <p className={style.infoText}>
                        Ya sea que tengas una consulta puntual o quieras conocer más sobre nuestros
                        servicios, un integrante de By Raíces va a leer tu mensaje y te va a responder
                        a la brevedad.
                    </p>

                    <div className={style.infoValues}>
                        <div className={style.infoValueItem}>
                            <span className={style.infoValueIcon}>💬</span>
                            <div>
                                <h3 className={style.infoValueTitle}>Respuesta personalizada</h3>
                                <p className={style.infoValueText}>Cada consulta es leída y respondida por una persona de nuestro equipo.</p>
                            </div>
                        </div>
                        <div className={style.infoValueItem}>
                            <span className={style.infoValueIcon}>🏡</span>
                            <div>
                                <h3 className={style.infoValueTitle}>Asesoramiento integral</h3>
                                <p className={style.infoValueText}>Te orientamos sobre compra, venta, alquiler o desarrollos según lo que necesites.</p>
                            </div>
                        </div>
                        <div className={style.infoValueItem}>
                            <span className={style.infoValueIcon}>⚖️</span>
                            <div>
                                <h3 className={style.infoValueTitle}>Respaldo profesional</h3>
                                <p className={style.infoValueText}>Todas las operaciones son intermediadas por corredores públicos matriculados.</p>
                            </div>
                        </div>
                    </div>
                </div>

             <div className={style.card}>
        <h2 className={style.title} >Envíenos un mensaje</h2>
        <p className={style.text}>Completá el formulario para contactarnos sobre cualquier pregunta o comentario que tengas y nos contactaremos a la brevedad.</p>

        <form className={style.mailForm} onSubmit={handleSubmit}>
           <label className={style.mailLabel} htmlFor="nombre">Nombre</label>
           <input className={style.inputText} type="text" name='nombre' id='nombre' value={formData.nombre} onChange={handleChange} placeholder="Tu nombre" required />

           <label className={style.mailLabel} htmlFor="mail">Correo electrónico</label>
           <input className={style.inputText} type="email" name='mail' id='mail' value={formData.mail} onChange={handleChange} placeholder="tuemail@mail.com" required />

           <label className={style.mailLabel} htmlFor="telefono">Teléfono</label>
           <input className={style.inputText} type="tel" name='telefono' id='telefono' value={formData.telefono} onChange={handleChange} placeholder="+54 9 11 1234 5678" />

           <label className={style.mailLabel} htmlFor="direccion">Dirección</label>
           <input className={style.inputText} type="text" name='direccion' id='direccion' value={formData.direccion} onChange={handleChange} placeholder="Calle y número" />

           <label className={style.mailLabel} htmlFor="asunto">Asunto</label>
           <input className={style.inputText} type="text" name="asunto" id="asunto" value={formData.asunto} onChange={handleChange} placeholder="Consulta general" />

           <label className={style.mailLabel} htmlFor="mensaje">Comentarios</label>
           <textarea className={style.inputText} name="mensaje" id="mensaje" cols="30" rows="5" value={formData.mensaje} onChange={handleChange} placeholder="Escribí tu consulta aquí..." required></textarea>

           <button className={style.btn} type="submit" disabled={isSending}>
             {isSending ? 'Enviando...' : 'Enviar'}
           </button>

           {status.message && (
             <div
               className={`${style.toast} ${status.type === 'success' ? style.toastSuccess : style.toastError}`}
               role="status"
               aria-live="polite"
             >
               {status.message}
             </div>
           )}
        </form>
   </div>
            </div>
   </div>
    );
};

export default Contact;